<script setup>
import FormTheming from "../../../components/ui-components/FormTheming.vue";
import FormThemingInteractive from "../../../components/ui-components/FormThemingInteractive.vue";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";
import {usePage} from "@inertiajs/vue3";
import Button from "primevue/button";
import { trans } from 'laravel-vue-i18n';

const model = defineModel()
const emit = defineEmits(["done"]);

const driverObj = driver({
    nextBtnText: trans('common.next'),
    prevBtnText: trans('common.back'),
    doneBtnText: trans('common.done'),
    showProgress: true,
    steps: [
        { element: '#form-wrapper', popover: { title: trans('forms.theme_title'), description: trans('forms.theme_description') } },
        { element: '#form-logo', popover: { title: trans('forms.theme_branding'), description: trans('forms.theme_branding_description') } },
        { element: '#form-background', popover: { title: trans('forms.theme_background'), description: trans('forms.theme_background_description') } },
        { element: '#form-panel', popover: { title: trans('forms.theme_panel'), description: trans('forms.theme_panel_description') } },
        { element: '#form-dark-mode', popover: { title: trans('forms.theme_dark_mode'), description: trans('forms.theme_dark_mode_description') } },
    ]
});

if (!usePage().props.hasForms) {
    driverObj.drive();
}
</script>

<template>
    <div class="-mt-8 relative" id="form-wrapper">
        <div class="absolute -top-4 right-0">
            <Button icon="pi pi-question-circle" text rounded @click="driverObj.drive()"></Button>
        </div>
        <form-theming-interactive v-model:theme="model.formTheme" v-model:settings="model.formSettings" :custom-form="model.formBuilder" :forms="model.settings" absolute></form-theming-interactive>
    </div>
</template>

<style lang="scss">
.driver-popover > *, .driver-popover-title {
    font-family: "Syne", system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif!important;
}
.driver-popover-footer button {
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    border: 1px solid gray;
    padding: var(--button-padding-y) var(--button-padding-x);
    font-size: 1rem;
    font-family: inherit;
    font-feature-settings: inherit;
    transition: background var(--button-transition-duration),color var(--button-transition-duration),border-color var(--button-transition-duration),outline-color var(--button-transition-duration),box-shadow var(--button-transition-duration);
    border-radius: 4999px;
    outline-color: transparent;
    gap: var(--button-gap);
}
</style>
